<template>
  <div>
    <container-headline
      :headline="$t('global.communicationdetails')"
      :col="6"
    ></container-headline>
    <div class="row mb-3">
      <div class="col-xl-12 block br-t-l-0">
        <div class="eingabe-panel-kopf p-3">
          <div class="row">
            <div class="col-xl-4">
              <div class="form-group d-flex align-items-center pos-r">
                <label>{{ $t("global.businessphone") }}</label>
                <div class="input-wrapper d-flex align-items-center pos-r">
                  <vue-tel-input
                    class="phone-input padding-right-35px"
                    id="phone-business"
                    v-model="telefonG"
                    :disabled="!editable"
                    :inputOptions="inputOptions"
                    mode="international"
                  ></vue-tel-input>
                  <div
                    class="call-button pos-a top-0 right-0 bottom-0 d-flex padding-x-10px clickable hover-success"
                    @click="call(telefonG)"
                  >
                    <font-awesome-icon
                      icon="fa-duotone fa-phone-arrow-up-right"
                      class="m-auto"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-4">
              <div class="form-group">
                <input
                  v-model.trim="firma.website"
                  class="form-control"
                  placeholder=" "
                  :readonly="!editable"
                />
                <label>{{ $t("global.website") }}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContainerHeadline from "@/components/ContainerHeadline";

export default {
  name: "FirmaKommunikationsangabenNewViva",
  components: {
    ContainerHeadline,
  },
  mixins: [],
  props: {
    firma: {
      type: Object,
      required: true,
    },
    editable: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      telefonG: null,
      dropdownOptions: { showFlags: true },
      data: { g: "" },
    };
  },
  computed: {
    inputOptions() {
      return { placeholder: this.$t("global.enteraphonenumber") };
    },
  },
  watch: {
    telefonG: {
      handler: function () {
        //if (val && val != this.firma.telefonG) this.updateCommunication();
        this.updateCommunication();
      },
    },
    firma: {
      deep: true,
      handler: function () {
        this.telefonG = this.firma.telefonG ? this.firma.telefonG : "";
      },
    },
  },
  created() {},
  methods: {
    updateCommunication() {
      this.$emit("commChanged", {
        g: this.telefonG ? this.telefonG : "",
      });
    },
    call(telefonnummer) {
      if (telefonnummer) window.location.href = `tel:${telefonnummer}`;
    },
  },
};
</script>

<style>
</style>

